import { Alert } from 'react-bootstrap';
import React from 'react';

function AlertDismissable({ show, dismiss, message, type }) {
  if (show) {
    return (
      <Alert variant={type === 'error' ? 'danger' : 'success'} onClose={dismiss} dismissible>
        <Alert.Heading>{type === 'error' ? 'Oh snap! You got an error!' : 'Success!'}</Alert.Heading>
        <p>{message}</p>
      </Alert>
    );
  }
  return <></>;
}

export { AlertDismissable };
